import $ from "jquery"

class Like {

    // 1. Initiate 
    constructor() {
        this.events();
    }

    // 2. Events
    events() {
        $('.like-box').on('click', this.ourClickDispatcher.bind(this));
    }

    // 3. Methods 
    ourClickDispatcher(e) {
        var currentLikeBox = $(e.target).closest(".like-box");
        console.log(currentLikeBox);
        if (currentLikeBox.attr('data-exists') == 'yes')
            this.deleteLike(currentLikeBox);
        else
            this.createLike(currentLikeBox);
    }

    createLike(currentLikeBox) {
        console.log("create");
        var postData = {
            professorId: currentLikeBox.data('professorid')
        };
        $.ajax({
            beforeSend: (xhr) => {
                xhr.setRequestHeader('X-WP-Nonce', excelsis_data.nonce);
            },
            url: excelsis_data.root_url + '/wp-json/excelsis/v1/manageLike',
            type: 'POST',
            data: postData,
            success: (response) => {
                currentLikeBox.attr('data-exists', 'yes');
                var likeCount = parseInt(currentLikeBox.find('.like-count').html(), 10) + 1;
                currentLikeBox.find('.like-count').html(likeCount);
                console.log(response);
            },
            error: (response) => { 
                console.log(response);
            }
        });
    }

    deleteLike(currentLikeBox) {
        console.log("delete");
        var postData = {
            professorId: currentLikeBox.data('professorid')
        };
        $.ajax({
            beforeSend: (xhr) => {
                xhr.setRequestHeader('X-WP-Nonce', excelsis_data.nonce);
            },
            url: excelsis_data.root_url + '/wp-json/excelsis/v1/manageLike',
            type: 'DELETE',
            data: postData,
            success: (response) => {
                currentLikeBox.attr('data-exists', 'no');
                var likeCount = parseInt(currentLikeBox.find('.like-count').html(), 10) - 1;
                currentLikeBox.find('.like-count').html(likeCount);
                console.log(response);
            },
            error: (response) => {
                console.log(response);
            }
        });
    }
}

export default Like